import React from 'react';
import { useAtomValue, useSetAtom } from 'jotai/index';
import { closeModalAtom } from '../../atoms/globalAtoms';
import MyButton from '../MyButton';

function InfoModal({
  title = 'Ошибка', text, buttonText = 'Ок', onButtonClick, buttonLoading, buttonClassName,
}) {
  const closeModal = useSetAtom(closeModalAtom);

  const onClick = (ev) => {
    if (typeof onButtonClick === 'function') {
      onButtonClick(ev);
    } else {
      closeModal();
    }
  };

  return (
    <div className="modal_wrapper">
      <div className="modal_content">
        <p className="modal_title">{title}</p>
        <p className="modal_descr">{text}</p>
      </div>
      <div style={{width:'100%'}}>
        <MyButton text={buttonText} onClick={onClick} loading={buttonLoading} className={buttonClassName} />
      </div>
    </div>
  );
}

export default InfoModal;
